<template>
  <div class="content freelist" v-loading="pageLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">服务人员姓名</div>
          <el-input
            size="mini"
            v-model="staffName"
            placeholder="请输入姓名"
            class="ipt-sty"
          />
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">服务人员手机号</div>
          <el-input
            size="mini"
            v-model="mobileNo"
            placeholder="请输入手机号"
            class="ipt-sty"
          />
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">公司名称</div>
          <el-select
            size="mini"
            v-model="tenantGuid"
            placeholder="请选择"
            filterable
            clearable
            class="ipt-sty"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" >
      <div class="button-area">
        <el-button size="mini" type="info" @click="batchClean"
          >批量清除</el-button
        >
      </div>
      <el-table
        :data="tableData"
        ref="multipleTable"
        stripe
        border
        :height="tableHeight"
        
        v-loading="loading"
        :row-key="(row) => row.guid"
        @row-click="handleClickTableRow"
        @selection-change="handleSelectionChange"
      >
        <el-table-column 
          type="selection" 
          width="40" 
          header-align="center" 
          align="center"
          fixed="left"
          ></el-table-column>
        <el-table-column
          label="序号"
          header-align="center"
          align="center"
          fixed="left"
          width="60"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="staffName"
          :render-header="renderHeader"
          label="服务人员姓名"
          header-align="center"
          align="left"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.staffName || "-"}}</template>
        </el-table-column>
        <el-table-column
          prop="mobileNo"
          label="服务人员手机号"
          header-align="center"
          align="left"
          min-width="140"
        >
          <template slot-scope="scope">{{ scope.row.mobileNo || "-"}}</template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="公司名称"
          header-align="center"
          align="left"
          min-width="240"
        >
        <template slot-scope="scope">{{ scope.row.tenantName || "-" }}</template>
          
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="账号注册时间"
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{  scope.row.createTime | getTimeDate}}</template>
        </el-table-column>

        
        <!-- <el-table-column
          prop="baseStaffName"
          label="微信ID所属人名"
          header-align="center"
          align="left"
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.baseStaffName || "-" }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="baseMobileNo"
          label="微信ID所属手机号"
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.baseMobileNo || "-" }}</template>
        </el-table-column> -->

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          min-width="80"
        >
          <template slot-scope="scope">
            <a class="txt-color" @click="cleanID(scope.row)">清除</a>
            
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

   
  </div>
</template>

<script>
  import { route } from "@/api/apiRoute";
  export default {
    data() {
      return {
        tableHeight: window.innerHeight - 280,
        pageLoading:false,
        loading: false,
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
        },
        staffName: "",
        mobileNo: "",
        staffOrMobileNo: "",
        tenantGuid: "",
        tableData:[],//列表
        tenantList: [],// 公司列表
        multipleSelection:[],//列表多选
      };
    },
    
    created() {
      // this.getList();
    },
    mounted() {
      this.search(true);
      this.getTenantList()
    },
    watch: {
      
    },
    methods: {
      // 获取列表
      search(flg) {
        let that = this;
        if(flg){
          that.page.pageIndex=1
        }
        let userInfo = JSON.parse(localStorage.userInfo);
        that.loading = true;
        that.tableData = [];
        let req = {
          currentTenantGuid:localStorage.guid,
          userGuid:userInfo.userGuid,
          pageIndex: that.page.pageIndex,
          pageSize: that.page.pageSize,
          // staffOrMobileNo: that.staffOrMobileNo || "",
          staffName: that.staffName || "",
          mobileNo: that.mobileNo || "",
          tenantGuid: that.tenantGuid || "",
        };
        that.api
          .postJson(
            `/${serverConfig.msPersonnelService}/batchClearOpenid/data/list`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tableData = res.data.data.records||[];
              that.page.totalPage = res.data.data.totalPages;
              that.page.totalRows = res.data.data.totalRows;
              that.loading = false;
              // console.log("that.tableData", that.tableData);
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 获取公司列表
      getTenantList(flg) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            "&tenantGuid=" +
            localStorage.guid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //批量清除
      batchClean() {
        console.log('..',this.multipleSelection);
        
        if (!this.multipleSelection.length) {
          this.$message.error("请勾选数据！");
          return;
        }
        this.cleanID()
      },
      // 清除id
      cleanID(row){
        let that = this;
        let guids=[]
        if(row){//单个清除
          guids.push(row.guid);
        }else{//批量清除
          guids=this.multipleSelection
        }
        this.$confirm('此操作将永久清除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
            that.loading = true;
            that.api.put(
                `/${serverConfig.msPersonnelService}/batchClearOpenid/data/clean`,
                guids
              )
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  that.multipleSelection = [];
                  that.$message.success('清除成功');
                  that.search(true);
                  that.loading = false;
                } else {
                  that.loading = false;
                  that.$message.error(res.data.msg);
                }
              });
            
        }).catch(() => {
            this.$refs.multipleTable.clearSelection();
            this.$message({
              type: 'info',
              message: '已取消清除',
            });
        });
            
      },
      // 清空搜索
      emptySearch() {
        // this.staffOrMobileNo = "";//服务人员信息
        this.staffName = "",
        this.mobileNo = "",
        this.tenantGuid = "";//公司名称
        this.search(true);
      },
      // 表格多选
      handleSelectionChange(val) {
        let that=this
        this.multipleSelection = [];
        if (val && val.length > 0) {
          val.forEach(item=>{
            that.multipleSelection.push(item.guid);
          });
        }
      },
      // 分页
      handleSizeChange(val) {
        let that = this;
        that.page.pageSize = val;
        this.search(true);
      },
      handleCurrentChange(val) {
        let that = this;
        that.page.pageIndex = val;
        this.search();
      },
      //点击行选中
      handleClickTableRow(row, event, column) {
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      
      renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'light',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              ['表格中展示您(当前登录账号)历史协助登录过的服务人员账号'],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    
    },
  };
</script>
<style lang="less" scoped>
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
.show-pop{
  color: #4fa1a4;
}
.tips-class{
  width: 90%;
  margin: auto;
  color: #4fa1a4;
  text-align: left;
  font-size: 12px;
}
  .el-table /deep/ .el-input__inner {
    height: 30px;
    line-height: 40px;
  }

  .el-range-editor.el-input__inner {
    padding: 0px;
  }

  /deep/ .el-checkbox__label {
    display: none;
  }

  /deep/ .configure-fields {
    width: 800px !important;
  }
  /deep/ .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  .field-radio {
  display: flex;
  align-items: center;
}

.field-radio /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
/deep/ .el-form-item {
  margin-bottom: 8px;
}
 /* 选项内容样式 */
 /deep/ .select-content-box {
    width: 92%;
    margin: 0 0px 10px 30px;
  }
  /deep/ .select-content {
    width: 100%;
    /* padding:0 10px; */
    background: #fafafa;
    border: 1px solid #e5e5e5;
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }

  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }

  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }

  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }

  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }

  // .content {
  //   background: #fff;
  //   font-size: 18px;
  // }

  .title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .title span {
    width: 6px;
    height: 14px;
    background: #4fa1a4;
    display: inline-block;
    margin-right: 10px;
  }

  .base {
    background: #fff;
    padding: 10px 0;
  }

  .content h1 {
    margin: 4px 0px;
  }

  .base-content {
    display: flex;
    font-size: 15px;
    padding: 7px 0;
  }

  .base-content .base-info {
    display: flex;
    align-items: center;
    padding: 0 40px;
  }

  .base-content .base-info .base-title {
    word-break: keep-all;
  }

  .button-area {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    margin-top: 0;
  }

  /deep/.el-checkbox__label {
    display: block;
  }

  .checkbox-show {
    display: flex;
    margin-bottom: 10px;
  }
  .field-show {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px;
  }

  .product {
    display: flex;
    align-items: center;
  }

  .product-img {
    width: 60px;
    height: 40px;
    margin-right: 15px;
  }

  .product-text {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-col-5 {
    width: 33%;
  }

  .ipt-sty {
    width: 69% !important;
  }
  .add-btn {
    width: 80%;
    height: 28px;
    line-height: 28px;
    margin-top: 8px;
    padding: 0;
  }
  .flex {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }
  .flex1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .checkTag {
    background-color: rgb(242, 242, 242);
  }
  .btn {
    display: none;
  }
  .btn a {
    cursor: pointer;
  }
  .el-table__body tr:hover .btn {
    display: block;
  }

  /deep/.el-tree-node__label {
    width: 80%;
    white-space: normal;
    overflow: hidden;
    text-align: left;
  }

  .el-tree-node__content {
    height: auto;
  }

  .radio-ora {
    margin-right: 12px;
  }

  .staff-type {
    display: inline-block;
    width: 72px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-type-biz {
    display: inline-block;
    width: 52px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-wrap {
    color: #d8814b;
    background: rgba(255, 238, 224, 0.39);
  }

  .biz-state {
    display: inline-block;
    width: 48px;
    height: 21px;
    line-height: 21px;
    background: rgba(239, 239, 239, 0.38);
    border-radius: 11px;
    margin-left: 5px;
  }

  .select-node {
    margin: 0 0 17px 0;
    text-align: left;
    font-size: 18px;
    color: #323233;
  }

  .custom-tree-node {
    display: inline-flex;
    overflow: hidden;
  }

  .content-main-box {
    overflow-y: visible;
  }

  .search-area-div{
    flex-shrink: 0;
    margin-right: 4px
  }
  .ipt-sty{
    flex: 1;
  }
  .el-col-6{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-12{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-8{
    display: flex;
    // margin-bottom: 15px;
    justify-content: flex-end;
  }
  /* .el-pagination {
    width: calc(100% - 260px - 231px);
  } */
</style>

